import ContractorsTableApp from '../../Functionality/ContractorsTableApp';
import CustomTable from '../../../../../components/table/CustomTable';
import {permissionObj} from '../../../../../Helpers/permission';
import React from 'react';
import DisplayView from '../../../../../components/DisplayView';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import routes from '../../../../../Routes/routes';
import {getViewTypeByName} from '../../../../../enums/ViewType';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ContractorsTable = (props) => {

    const {
        view,
        setView,
        contractorId,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        searchElement,
        setSearchElement,
        supplierId,
        search,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        modified,
        setModified,
        setDeleteContractorShow,
        setCriteria,
        finalArray
    } = props;

    const {
        t,
        navigate,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        option,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        setResults,
        rowsPerPage,
        deletePermission
    } = ContractorsTableApp({
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setIsAllChecked,
        setDeleteContractorShow,
        searchElement,
        setSearchElement,
        contractorId,
        setCriteria,
        finalArray,
        search,
        setSearch,
        setBodyForExport
    });

    return (
        <>
            <div className={"d-flex"}>
                <DisplayView view={view} setView={setView} left={0} />
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={"txt_ct_search_contractors"}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={contractorId}
                        supplierId={supplierId}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                        <div className={"warning-text"}>
                            <p>{t("you_haven_not_created_any_contractor")}</p>
                        </div>
                        { (DEV || permission?.includes(permissionObj?.WEB_CONTRACTOR_CREATE)) &&
                        <CustomButtonLink splitName={false} id={'btn_ct_create'} card={true}
                                          onClick={() => navigate(routes.contractor.create)}
                                          name={'create_new_contractor'}/>
                        } </>
                    : undefined
                }
            />

            { pagination() }
        </>
    );

}

export default ContractorsTable
